import React, { useEffect } from "react";
import {
    Alert,
    Avatar,
    Button,
    Card,
    Collapse,
    Grid,
    IconButton,
    Typography,
    MenuItem
} from "@mui/material";
import FeatherIcon from "feather-icons-react";

import PageContainer from "../../../components-v2/container/PageContainer";
import Breadcrumb from "../../../layouts-v2/full-layout/breadcrumb/Breadcrumb";

import av1 from "../../../assets-v2/images/users/4.jpg";
import CustomFormLabel from "../../../components-v2/forms/custom-elements/CustomFormLabel";
import CustomSelect from "../../../components-v2/forms/custom-elements/CustomSelect";
import { useParams } from "react-router-dom";
import UserService from "../../../services-v2/eitri-manager-api/OrganizationUserService";
import { Roles } from "../../../utils-v2/enums/Roles";
import Storage from "../../../services-v2/storage/Storage";
import useAlert from "../../../hooks/useAlert";
import useStatus from "../../../hooks/useStatus";

import Loading from "../../../layouts-v2/loading/Loading";

const UserEdit = () => {
    const params = useParams();
    const [user, setUser] = React.useState({
        email: "",
        userId: "",
        organizationId: "",
        role: ""
    });
    const [orgName, setOrgName] = React.useState("");
    const [role, setRole] = React.useState("");
    const [roles, setRoles] = React.useState([]);
    const { alertInfo, setAllAlertInfo, setInitialAlertInfo } = useAlert();
    const { status, setAllStatus } = useStatus();

    useEffect(() => {
        initializeView();
    }, []);

    const initializeView = async () => {
        setAllStatus({ isFetching: true, success: false, error: false });
        try {
            findOrgName();
            await finduser(params.email);
            await findOrgUserRoles();
            setAllStatus({ isFetching: false, success: true, error: false });
        } catch (e) {
            setAllStatus({ isFetching: false, success: false, error: true });
            setAllAlertInfo({
                theme: "error",
                message: e.message,
                visible: true
            });
        }
    };

    const finduser = async email => {
        try {
            const user = await UserService.findByEmail(email);
            console.log(user);
            if (!user) {
                throw new Error("Usuário não encontrado.");
            }
            setUser(user);
        } catch (e) {
            console.error("Ocorreu um erro ao tentar recuperar o usuário.", e);
            throw new Error("Usuário não encontrado.");
        }
    };

    const findOrgName = () => {
        const organizationStorage = Storage.get(Storage.KEYS.ORGANIZATION_DATA);
        const organizationName = JSON.parse(organizationStorage)?.name;
        setOrgName(organizationName);
    };

    const findOrgUserRoles = async () => {
        try {
            const roles = await UserService.getOrgUserRoles();
            const roleList = roles.map(role => {
                const item = Roles[role];
                return {
                    value: role,
                    label: item
                };
            });
            setRoles(roleList);
        } catch (e) {
            console.error("Ocorreu um erro ao tentar recuperar as roles.", e);
            throw new Error(
                "O sistema não está funcionando conforme esperado. Já estamos trabalhando para ajustar esse desconforto."
            );
        }
    };

    const updateUser = async () => {
        try {
            setAllStatus({ isFetching: true, success: false, error: false });
            const updatedUser = {
                organizationId: user.organizationId,
                userId: user.userId,
                id: user.id,
                email: user.email,
                role: role,
                createdAt: user.createdAt
            };
            await UserService.updateUser(updatedUser);
            finduser(user.email);
            setAllAlertInfo({
                theme: "success",
                message: "Usuário atualizado com sucesso!",
                visible: true
            });
            setAllStatus({ isFetching: false, success: true, error: false });
        } catch (e) {
            setAllAlertInfo({
                theme: "error",
                message: "Ops! Não foi possível atualizar o usuário.",
                visible: true
            });
            console.error(
                "Ocorreu um erro ao tentar atualizar o usuário: ",
                e.message
            );
            setAllStatus({ isFetching: false, success: false, error: true });
        }
    };

    const BCrumb = [
        {
            to: "/user-management/users/",
            title: "Usuários"
        },
        {
            title: "Editar Usuário"
        }
    ];

    return (
        <>
            {status.isFetching ? (
                <Loading isVisible={status.isFetching} />
            ) : (
                <PageContainer
                    title="Editar Usuário"
                    description="this is Customer Edit page"
                >
                    <Collapse in={alertInfo.visible}>
                        <Alert
                            variant="filled"
                            severity={alertInfo.theme || "info"}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setInitialAlertInfo();
                                    }}
                                >
                                    <FeatherIcon icon="x" width="20" />
                                </IconButton>
                            }
                        >
                            {alertInfo.message}
                        </Alert>
                    </Collapse>
                    <Breadcrumb items={BCrumb} />
                    <Grid container spacing={0}>
                        <Grid item lg={4} md={12} xs={12}>
                            <Card sx={{ p: 3 }}>
                                <Avatar
                                    alt="Remy Sharp"
                                    src={av1}
                                    sx={{ width: 110, height: 110 }}
                                />
                                <Typography variant="h2" sx={{ mt: 1 }}>
                                    {user?.email || "-"}
                                </Typography>
                                <Typography variant="body2">
                                    <span id={"cypress-user-role"}>
                                        {user?.role
                                            ? Roles[user.role].toLowerCase()
                                            : "-"}
                                    </span>
                                </Typography>
                                <Typography
                                    variant="h6"
                                    fontWeight="600"
                                    sx={{ mt: 3, mb: 1 }}
                                >
                                    Organização
                                </Typography>
                                <Typography variant="body2">
                                    {orgName?.toLowerCase() || "-"}
                                </Typography>
                            </Card>
                        </Grid>
                        {user?.email && (
                            <Grid item lg={8} md={12} xs={12}>
                                <Card sx={{ p: 3 }}>
                                    <Typography
                                        variant="h6"
                                        fontWeight="600"
                                        sx={{ mb: 3 }}
                                    >
                                        Atualizar Detalhes
                                    </Typography>
                                    <form>
                                        <CustomFormLabel htmlFor="role">
                                            Role
                                        </CustomFormLabel>
                                        <CustomSelect
                                            fullWidth
                                            id="role"
                                            variant="outlined"
                                            value={role}
                                            onChange={e =>
                                                setRole(e.target.value)
                                            }
                                            size="small"
                                            sx={{
                                                mb: 2
                                            }}
                                        >
                                            {roles.map(option => (
                                                <MenuItem
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </CustomSelect>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            onClick={updateUser}
                                        >
                                            Atualizar
                                        </Button>
                                    </form>
                                </Card>
                            </Grid>
                        )}
                    </Grid>
                </PageContainer>
            )}
        </>
    );
};

export default UserEdit;
